import React, { useEffect } from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import { ButtonPrimary } from '@spotify-internal/encore-web';
import { useT } from 'i18n/hooks/useT';
import { events, SpotifyConnectComponent } from '../events';

type SpotifyConnectErrorModalProps = {
  onRetry: () => void;
  onClose: () => void;
  component: SpotifyConnectComponent;
  location: string;
};

export const SpotifyConnectErrorModal = ({
  onRetry,
  onClose,
  component,
  location,
}: SpotifyConnectErrorModalProps) => {
  const t = useT();

  useEffect(() => {
    events.screenView('connect_to_spotify_error_modal', location, component);
  }, [location, component]);

  return (
    <Modal
      isShowingCloseButton
      onClose={onClose}
      aria-labelledby="spotify-connect-error-modal-title"
    >
      <Modal.Title id="spotify-connect-error-modal-title">
        {t(
          'SpotifyConnectErrorModal.Body',
          'There was an issue linking your Spotify account.',
          'Linking Spotify account failed due to an error'
        )}
      </Modal.Title>
      <Modal.Footer>
        <ButtonPrimary onClick={onRetry}>
          {t('Button.Retry', 'Retry', 'Retry button text')}
        </ButtonPrimary>
      </Modal.Footer>
    </Modal>
  );
};
